import { useEffect } from 'react';
import { usePopupContext } from '@/contexts/PopupContext';

interface PopupRegistrationProps {
  name: string;
  context: string;
  isOpen: boolean;
  url?: string;
}

export const usePopupRegistration = ({ name, context, isOpen, url }: PopupRegistrationProps) => {
  const { registerPopup, unregisterPopup } = usePopupContext();

  useEffect(() => {
    if (isOpen) {
      registerPopup({
        name,
        context,
        url
      });
    } else {
      unregisterPopup();
    }

    // Cleanup when component unmounts
    return () => {
      unregisterPopup();
    };
  }, [isOpen, name, context, url]); // eslint-disable-line react-hooks/exhaustive-deps
};